"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Heading = require("../Heading/Heading");

var DialogHeader = function DialogHeader(_ref) {
  var text = _ref.text;
  return _react["default"].createElement(_Flex["default"], {
    width: 1 / 1,
    flexDirection: "column",
    pt: 3
  }, _react["default"].createElement(_Heading.H4, {
    fontSize: "20px",
    fontWeight: "500"
  }, text));
};

DialogHeader.propTypes = {
  text: _propTypes["default"].string.isRequired
};
var _default = DialogHeader;
exports["default"] = _default;